var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "wifi_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#wifi_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m9.972 25.278-2.917-2.945a20.37 20.37 0 0 1 5.931-4.138A16.577 16.577 0 0 1 20 16.667c2.463 0 4.803.511 7.02 1.534a20.152 20.152 0 0 1 5.925 4.16l-2.917 2.917a16.195 16.195 0 0 0-4.604-3.243A12.623 12.623 0 0 0 20 20.833c-1.907 0-3.715.4-5.424 1.202a16.195 16.195 0 0 0-4.604 3.243Zm-7.055-7.056L0 15.305a29.315 29.315 0 0 1 9.146-6.354A26.517 26.517 0 0 1 20 6.667c3.796 0 7.414.761 10.854 2.284A29.315 29.315 0 0 1 40 15.305l-2.917 2.917a27.993 27.993 0 0 0-7.868-5.382A21.878 21.878 0 0 0 20 10.833c-3.222 0-6.294.67-9.215 2.007a27.994 27.994 0 0 0-7.868 5.382ZM20 35.305l-6.07-6.11a8.639 8.639 0 0 1 2.771-1.862A8.386 8.386 0 0 1 20 26.667c1.148 0 2.248.222 3.299.666a8.639 8.639 0 0 1 2.77 1.862L20 35.305Z"
}))));
export default SvgWifi;